import ToastMessage from 'components/common/toast/ToastMessage';
import {toast} from 'react-toastify';

export default function helperService () {
// Toast alert
  const alert = (type = 'success', message) => {
    if(type === 'success'){
      toast.success(
        <ToastMessage icon='check-circle' msg={ message } />
      );
    } else if(type === 'error'){
      toast.error(
        <ToastMessage icon='times-circle' msg={ message } />
      );
    } else if(type === 'info') {
      toast.info(
        <ToastMessage icon='info-circle' msg={ message } />
      );
    } else if(type === 'warning'){
      toast.error(
        <ToastMessage icon='exclamation-circle' msg={ message } />
      );
    }
  };

  const getFullName = (item, firstNameKey, lastNameKey, nameKey = 'name') => {
    if(!item){
      return '';
    }
    if(!item[firstNameKey] && !item[lastNameKey]){
      return item[nameKey];
    } else if(!item[firstNameKey]){
      return item[lastNameKey];
    } else if(!item[lastNameKey]){
      return item[firstNameKey];
    }
    return `${item[firstNameKey]} ${item[lastNameKey]}`;
  };

  return {alert, getFullName};
}